<template>
    <CategoriesList
        heading="Product categories"
        api-base="product-categories"
        url-base="/products/categories"
    />
</template>

<script>
import CategoriesList from '../../components/categories/CategoriestList.vue';

export default {
    components: {
        CategoriesList,
    },
};
</script>

<style lang="postcss" scoped>
</style>
